import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "mediaTypeRadio", "customLinkSection", "hybridSection", "placeSection", "zoomSection"]

  updateMediaType() {
    const selected = this.element.querySelector("input[name*='media_type']:checked")?.value
    if (!selected) return

    this.toggleSection(this.customLinkSectionTarget, selected === "custom")
    this.toggleSection(this.hybridSectionTarget, selected !== "inperson")

    if (this.hasPlaceSectionTarget) {
      this.toggleSection(this.placeSectionTarget, selected === "inperson")
    }
    if (this.hasZoomSectionTarget) {
      this.toggleSection(this.zoomSectionTarget, selected === "zoom")
    }
  }

  updateHybrid() {
    if (!this.hasPlaceSectionTarget) return
    const hybrid = this.element.querySelector("input[name*='hybrid']:checked")?.value === "true"
    const mediaType = this.element.querySelector("input[name*='media_type']:checked")?.value
    this.toggleSection(this.placeSectionTarget, mediaType === "inperson" || hybrid)
  }

  toggleSection(target, show) {
    if (show) {
      target.classList.remove("hidden")
    } else {
      target.classList.add("hidden")
    }
  }
}
